<template>
  <img
    id="logo"
    :src="config.LOGO_PATH"
    alt="Aer"
    class="logo"
    :width="props.width"
    :height="props.height" />
</template>
<script lang="ts" setup>
import config from '@/config';
const props = withDefaults(
  defineProps<{
    width?: number;
    height: number;
  }>(),
  {
    width: 100,
    height: 100,
  }
);
</script>
<style scoped>
.logo {
  border-radius: var(--md-border-radius-md);
}
</style>
